import { ITCFGlobalVendorList } from "types/tcf";
import {
  ITCFLegIntCategoryName,
  ITCFVendorCategory,
  TCFCategoryTypes,
} from "../TCFConsentProvider/types";
import { AppStateContext } from "core/AppStateContext";
import { TCFLegIntCategoryName } from "../constantsTCF";

// Check if any vendor require this purpose, to not display purposes that are not used to not confuse the end users
const getTCFCategoryVendorCount = (
  purposesName: ITCFVendorCategory | ITCFLegIntCategoryName,
  purposeId: number,
  gvl: ITCFGlobalVendorList,
  selectedVendorsList: AppStateContext["tcfVendorsList"]
): number => {
  let count: number = 0;
  if (gvl) {
    // Loop through selected vendors and check purposes and legitimate interest
    selectedVendorsList.forEach((vendorId) => {
      if (gvl.vendors[vendorId][purposesName].includes(purposeId)) {
        count++;
      }
      // If category type is purpose check that vendor might require legitimate interest for this purpose
      else if (
        purposesName === TCFCategoryTypes.PURPOSES &&
        gvl.vendors[vendorId][TCFLegIntCategoryName].includes(purposeId)
      )
        count++;
    });
  }

  return count;
};

export default getTCFCategoryVendorCount;
